import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Link from '../../../common/components/link/internal-link';
import { connect } from '../../../common/components/runtime-context';
import { AppState } from '../../../common/types';
import {
  getIsSeeAllLinkLayoutText,
  getIsSeeAllLinkUppercase,
  getUseMobileSettings,
} from '../../selectors/see-all-link-selectors';
import styles from './see-all-link.scss';

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

export type SeeAllLinkProps = RuntimeProps;

const SeeAllLink = ({
  isTextLayout,
  isUppercase,
  useMobileSettings,
}: SeeAllLinkProps) => {
  const { t } = useTranslation();
  return (
    <Link
      to="/"
      className={classNames([
        { [styles.mobile]: useMobileSettings },
        isTextLayout ? styles.seeAllLinkText : styles.seeAllLinkButton,
      ])}
    >
      {isUppercase
        ? t('related-posts.see-all-link.label').toUpperCase()
        : t('related-posts.see-all-link.label')}
    </Link>
  );
};

const mapRuntimeToProps = (state: AppState) => ({
  isTextLayout: getIsSeeAllLinkLayoutText(state),
  isUppercase: getIsSeeAllLinkUppercase(state),
  useMobileSettings: getUseMobileSettings(state),
});

export default connect(mapRuntimeToProps)(SeeAllLink);
